import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSubscriptionTick1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="subscription-tick-1,verify"><path d="M11.9982 2.75L14.4447 5.56579L18.1288 4.98137L18.193 8.711L21.3909 10.6314L19.0427 13.5297L20.258 17.0564L16.5962 17.7673L15.2602 21.25L11.9982 19.4408L8.73612 21.25L7.40018 17.7673L3.73837 17.0564L4.95364 13.5297L2.60547 10.6314L5.80332 8.711L5.86752 4.98137L9.55163 5.56579L11.9982 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.5 12.75L11 14.25L14.5 10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSubscriptionTick1;
